export interface DataModelNode {
  name: string;
  type: 'string' | 'number' | 'integer' | 'date' | 'boolean' | 'object' | 'array';
  required?: boolean;
  example?: string | number;
  description?: string;
  children?: DataModelNode[];
}

export interface DataModelVariant {
  name: string;
  description?: string;
  root: DataModelNode;
}

interface DataModelSchemaBase {
  label: string;
  format: 'json' | 'xml';
}

interface SingleRootSchema extends DataModelSchemaBase {
  root: DataModelNode;
  variants?: never;
}

interface MultiVariantSchema extends DataModelSchemaBase {
  root?: never;
  variants: DataModelVariant[];
}

export type DataModelSchema = SingleRootSchema | MultiVariantSchema;

export function isMultiVariant(schema: DataModelSchema): schema is MultiVariantSchema {
  return 'variants' in schema && Array.isArray(schema.variants);
}
